module.exports = __webpack_public_path__ + "img/miner.5b0bc238.png";